module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAMAAAC67D+PAAAAD1BMVEUMDAwXFxcYGBgSEhIjIyPkFzeHAAAAKklEQVR42nXGsQEAIAzDMDf0/5uJ2dEkmDwDp3fNerfEuxDvWt9Z76z+vSm5AMtQHqfjAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dark/dark_bg_wave.png
// module id = 505
// module chunks = 0